import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  SimpleChanges,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { NzTreeComponent } from 'ng-zorro-antd';

@Component({
  selector: 'app-common-tree',
  templateUrl: './common-tree.component.html',
  styleUrls: ['./common-tree.component.scss'],
})
export class CommonTreeComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
  @ViewChild('nzTreeComponent') nzTreeComponent: NzTreeComponent;
  _nodes: any[];
  selectedValue = null;
  defaultSelectedKey = [];
  @Input() treeName = '';
  @Input() showCreateRoot = true;
  @Input() showCreateChild = true;
  @Input() showDisabled = true;
  @Input() showSearch = true;
  @Input()
  set nodes(v) {
    this._nodes = v;
    if (this._nodes.length > 0) {
      if (this.selectedValue) {
        if (this.selectedValue.origin) {
          this.defaultSelectedKey = [this.selectedValue.origin.key];
          this.selectedNode.emit(this.selectedValue.origin);
        } else {
          this.defaultSelectedKey = [this.selectedValue.key];
          this.selectedNode.emit(this.selectedValue);
        }
      } else {
        this.defaultSelectedKey = [this._nodes[0].key];
        this.selectedValue = { origin: this._nodes[0] };
        this.selectedNode.emit(this._nodes[0]);
      }
    }
  }
  get nodes() {
    return this._nodes;
  }
  isSpinning = false;
  searchValue = null;
  subscription = new Subscription();
  @Output() selectedNode = new EventEmitter();
  @Output() changeStatus = new EventEmitter();
  @Output() changeFormStatus = new EventEmitter(); // -1为只读，1为新增，2为编辑，3为新增根节点

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit() {}

  ngOnChanges(changes: SimpleChanges) {}

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  createRootCategory() {
    this.changeFormStatus.emit('3');
  }

  createCategory() {
    if (this.selectedValue) {
      this.changeFormStatus.emit('1');
    }
  }

  editCategory() {
    if (this.selectedValue) {
      this.changeFormStatus.emit('2');
    }
  }

  updateCategoryStatus() {
    this.changeStatus.emit('true');
  }

  selectCategory(event) {
    if (event.selectedKeys?.length === 0) {
      this.defaultSelectedKey = [event.node.key];
    }
    this.selectedValue = event.node;
    this.selectedNode.emit(event.node);
  }

  onDrop(event) {}
}
